import { useTranslate } from "@similarweb/i18n-provider";

import type { IChosenItem } from "app/components/compare/WebsiteQueryBar/WebsitePageQueryBarUtils";
import { YOUR_DOMAIN } from "app/modules/project-from-comparison/components/DomainListItem/text";
import { ItemActions } from "app/modules/project-from-comparison/components/ItemActions";
import { projectCreationDataAutomation } from "app/modules/project-from-comparison/dataAutomation";
import type { DomainFromAutoselect } from "app/modules/project-from-comparison/types";
import type { ISimilarSite } from "pro-features/components/Workspace/Wizard/src/types";

import * as SC from "./styles";

type DomainListItemProps = {
    domain: string;
    isPrimary: boolean;
    canRemove: boolean;
    excludes: IChosenItem[];
    similarSites: ISimilarSite[];
    icon: string;
    setIcon: (item: DomainFromAutoselect) => void;
    showVersus?: boolean;
};

export const DomainListItem = ({
    domain,
    isPrimary,
    canRemove,
    excludes,
    similarSites,
    icon,
    setIcon,
    showVersus = false,
}: DomainListItemProps) => {
    const { translate } = useTranslate();

    return (
        <>
            {showVersus ? <SC.VersusText>VS.</SC.VersusText> : null}

            <SC.Item
                data-domain={domain}
                data-automation={projectCreationDataAutomation.domainListItem.item}
            >
                <SC.IconContainer data-automation={projectCreationDataAutomation.domainListItem.iconContainer}>
                    <SC.Icon
                        src={icon}
                        width={16}
                        height={16}
                        data-automation={projectCreationDataAutomation.domainListItem.icon}
                    />
                </SC.IconContainer>

                <SC.Text
                    isPrimary={isPrimary}
                    data-automation={projectCreationDataAutomation.domainListItem.text}
                >
                    <SC.Name
                        isPrimary={isPrimary}
                        data-automation={projectCreationDataAutomation.domainListItem.name}
                    >
                        {domain}
                    </SC.Name>
                    {isPrimary ? `(${translate(YOUR_DOMAIN)})` : null}
                </SC.Text>

                <ItemActions
                    domain={domain}
                    isPrimary={isPrimary}
                    canRemove={canRemove}
                    excludes={excludes}
                    similarSites={similarSites}
                    setIcon={setIcon}
                />
            </SC.Item>
        </>
    );
};
